import React, { useCallback, useState } from 'react';

import { Tabs, TabsContent } from '@/components/ui/tabs';
import { CALENDAR_VIEWS } from '../../constants';
import { addMonths, addWeeks } from '../../utils';
import Footer from './Footer';
import Header from './Header';

const CalendarGrid = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentView, setCurrentView] = useState(CALENDAR_VIEWS.WEEK.value);

  const handleDateChange = useCallback(
    (offset) => {
      const offsetFn = currentView === CALENDAR_VIEWS.MONTH.value ? addMonths : addWeeks;
      setCurrentDate((prev) => offsetFn(prev, offset));
    },
    [currentView]
  );

  const handleDateReset = () => {
    setCurrentDate(new Date());
  };

  return (
    <Tabs
      className="flex flex-1 flex-col min-h-0"
      onValueChange={setCurrentView}
      value={currentView}
    >
      <Header
        currentDate={currentDate}
        currentView={currentView}
        onDateChange={handleDateChange}
        onDateReset={handleDateReset}
      />

      {Object.values(CALENDAR_VIEWS).map(({ component: Component, value }) => (
        <TabsContent
          className="flex flex-1 flex-col min-h-0 mt-0"
          key={value}
          value={value}
        >
          <Component currentDate={currentDate} />
        </TabsContent>
      ))}

      <Footer />
    </Tabs>
  );
};

export default CalendarGrid;
